import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Acadêmico → Parâmetros → Tabelas — migração de `CadastrarBairro.aspx`, `CadastrarMunicipio.aspx`,
 * `CadastrarProfissao.aspx` e das demais telas do menu (ver `docs/tabelas-auxiliares/`).
 *
 * UMA view para as 14 tabelas; a tabela vai em `meta.tabela` (a chave do catálogo da API). Uma
 * ROTA por tabela, escrita por extenso, e não uma rota parametrizada nem gerada por `map`:
 *  - o menu do legado abre a tela pelo NOME da rota e sem params;
 *  - cada tabela tem a sua permissão PRÓPRIA — liberar Religiões não libera Cidades;
 *  - `npm run ajuda-telas` só reconhece rota escrita por extenso.
 *
 * Situações do Estudante, Declarações Personalizadas e Tipos de Ocorrência, do mesmo menu legado,
 * já foram migradas em outras telas (ver o README).
 */
export default [
  {
    description: 'Tipos de Responsável',
    path: '/academico/parametros/tabelas/tiposresponsavel',
    name: 'tabela_tipos_responsavel',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'tiposresponsavel',
      permissions: [eTipoPermissao.TIPODERESPONSAVELNOVO_MENU_300901018],
    },
    goesToMenu: true,
  },
  {
    description: 'Tipos de Renovação',
    path: '/academico/parametros/tabelas/tiposrenovacao',
    name: 'tabela_tipos_renovacao',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'tiposrenovacao',
      permissions: [eTipoPermissao.TIPODERENOVACAONOVO_MENU_300901019],
    },
    goesToMenu: true,
  },
  {
    description: 'Transporte Escolar',
    path: '/academico/parametros/tabelas/transportes',
    name: 'tabela_transportes',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'transportes',
      permissions: [eTipoPermissao.TRANSPORTEESCOLARNOVO_MENU_300901020],
    },
    goesToMenu: true,
  },
  {
    description: 'Bairros',
    path: '/academico/parametros/tabelas/bairros',
    name: 'tabela_bairros',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'bairros',
      permissions: [eTipoPermissao.BAIRROSNOVO_MENU_300901021],
    },
    goesToMenu: true,
  },
  {
    description: 'Cidades',
    path: '/academico/parametros/tabelas/cidades',
    name: 'tabela_cidades',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'cidades',
      permissions: [eTipoPermissao.CIDADESNOVO_MENU_300901022],
    },
    goesToMenu: true,
  },
  {
    description: 'Profissões',
    path: '/academico/parametros/tabelas/profissoes',
    name: 'tabela_profissoes',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'profissoes',
      permissions: [eTipoPermissao.PROFISSOESNOVO_MENU_300901023],
    },
    goesToMenu: true,
  },
  {
    description: 'Religiões',
    path: '/academico/parametros/tabelas/religioes',
    name: 'tabela_religioes',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'religioes',
      permissions: [eTipoPermissao.RELIGIOESNOVO_MENU_300901024],
    },
    goesToMenu: true,
  },
  {
    description: 'Tipos de Logradouro',
    path: '/academico/parametros/tabelas/tiposlogradouro',
    name: 'tabela_tipos_logradouro',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'tiposlogradouro',
      permissions: [eTipoPermissao.TIPOLOGRADOUROSNOVO_MENU_300901025],
    },
    goesToMenu: true,
  },
  {
    description: 'Logradouros',
    path: '/academico/parametros/tabelas/logradouros',
    name: 'tabela_logradouros',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'logradouros',
      permissions: [eTipoPermissao.LOGRADOUROSNOVO_MENU_300901026],
    },
    goesToMenu: true,
  },
  {
    description: 'Regiões',
    path: '/academico/parametros/tabelas/regioes',
    name: 'tabela_regioes',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'regioes',
      permissions: [eTipoPermissao.REGIOESNOVO_MENU_300901027],
    },
    goesToMenu: true,
  },
  {
    description: 'Motivos',
    path: '/academico/parametros/tabelas/motivos',
    name: 'tabela_motivos',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'motivos',
      permissions: [eTipoPermissao.MOTIVOSNOVO_MENU_300901028],
    },
    goesToMenu: true,
  },
  {
    description: 'Etapas do PET',
    path: '/academico/parametros/tabelas/petetapas',
    name: 'tabela_pet_etapas',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'petetapas',
      permissions: [eTipoPermissao.PETETAPASNOVO_MENU_300901029],
    },
    goesToMenu: true,
  },
  {
    description: 'Cargos',
    path: '/academico/parametros/tabelas/cargos',
    name: 'tabela_cargos',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'cargos',
      permissions: [eTipoPermissao.CARGOSNOVO_MENU_300901030],
    },
    goesToMenu: true,
  },
  {
    description: 'Fundamentações Legais',
    path: '/academico/parametros/tabelas/fundamentacoeslegais',
    name: 'tabela_fundamentacoes_legais',
    component: () => import('@/views/academico/parametros/tabelas/Index.vue'),
    meta: {
      tabela: 'fundamentacoeslegais',
      permissions: [eTipoPermissao.FUNDAMENTACOESLEGAISNOVO_MENU_300901031],
    },
    goesToMenu: true,
  },
];
